'use client';

import GenderFemale from '../../../../../public/images/tests/gender-sign-female.svg';
import GenderMale from '../../../../../public/images/tests/gender-sign-male.svg';

type Props = {
    gender: 'male' | 'female';
};

export default function GenderSign({ gender }: Props) {
    return gender === 'male' ? <GenderMale /> : <GenderFemale />;
}
